import CookieService from '@/services/storage/general/cookie-service';
import { SessionCookieData } from 'auth-types';

const SessionService = {
  getSessionCookie(): SessionCookieData | undefined {
    return CookieService.get('SESSION') as unknown as SessionCookieData;
  },

  setSessionCookie(data: SessionCookieData): void {
    CookieService.set('SESSION', data);
    return;
  },

  resetSessionCookie(): void {
    CookieService.delete('SESSION');
    return;
  },
};

export default SessionService;
